export enum FileType {
  SVG = 'SVG',
  PNG = 'PNG',
  JPG = 'JPG',
  GIF = 'GIF',
  PDF = 'PDF',
  MP4 = 'MP4',
}
